import { createRouter, createWebHistory } from 'vue-router'

const Home = () => import('@/components/Pages/Home')
const Landing = () => import('@/components/Pages/Landing')
const AddCard = () => import('@/components/Pages/AddCard')
const Learn = () => import('@/components/Pages/Learn')
const Card = () => import('@/components/Pages/Card')
const Settings = () => import('@/components/Pages/Settings')
const Plans = () => import('@/components/Pages/Plans')
const Explorer = () => import('@/components/Pages/Explorer')
const LegalCgu = () => import('@/components/Pages/LegalCgu')
const LegalPrivacy = () => import('@/components/Pages/LegalPrivacy')
const LegalNotice = () => import('@/components/Pages/LegalNotice')
const LegalCookies = () => import('@/components/Pages/LegalCookies')
const NoRoleAccess = () => import('@/components/Pages/NoRoleAccess')
const Documentation = () => import('@/components/Pages/Documentation')
const Onboarding = () => import('@/components/Pages/Onboarding')
const TeacherStats = () => import('@/components/Pages/TeacherStats')

const routes = [
  {
    path: '/acces-refuse',
    name: 'NoRoleAccess',
    component: NoRoleAccess
  },
  {
    path: '/cgu',
    name: 'LegalCgu',
    component: LegalCgu
  },
  {
    path: '/confidentialite',
    name: 'LegalPrivacy',
    component: LegalPrivacy
  },
  {
    path: '/mentions-legales',
    name: 'LegalNotice',
    component: LegalNotice
  },
  {
    path: '/cookies',
    name: 'LegalCookies',
    component: LegalCookies
  },
  {
    path: '/',
    name: 'Landing',
    component: Landing
  },
  {
    path: '/documentation',
    name: 'Documentation',
    component: Documentation
  },
  {
    path: '/app',
    name: 'HomePage',
    component: Home,
    meta: {
      breadcrumb: [
        { name: 'Accueil' }
      ],
      isAuthenticated: true
    }
  },
  {
    path: '/cat/:id',
    name: 'HomePageCat',
    component: Home,
    meta: {
      breadcrumb: [
        { name: 'Accueil' }
      ],
      isAuthenticated: true
    }
  },
  {
    path: '/search/:keyword',
    name: 'HomePageSearch',
    component: Home,
    meta: {
      breadcrumb: [
        { name: 'Accueil' }
      ],
      isAuthenticated: true
    }
  },
  {
    path: '/learn/:id',
    name: 'Learn',
    component: Learn,
    meta: {
      breadcrumb: [
        { name: 'Accueil', link: 'HomePageCat' },
        { name: 'Mes cartes', link: 'Card' },
        { name: 'Cartes du jour' }
      ],
      isAuthenticated: true
    }
  },
  {
    path: '/card/:id',
    name: 'Card',
    component: Card,
    meta: {
      breadcrumb: [
        { name: 'Accueil', link: 'HomePageCat' },
        { name: 'Mes cartes' }
      ],
      isAuthenticated: true
    }
  },
  {
    path: '/add-card/:id',
    name: 'AddCard',
    component: AddCard,
    meta: {
      breadcrumb: [
        { name: 'Accueil', link: 'HomePageCat' },
        { name: 'Carte', link: 'Card' },
        { name: 'Ajouter une carte' }
      ],
      isAuthenticated: true
    }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    meta: {
      breadcrumb: [
        { name: 'Accueil', link: 'HomePage' },
        { name: 'Paramètres' }
      ],
      isAuthenticated: true
    }
  },
  {
    path: '/plans',
    name: 'Plans',
    component: Plans,
    meta: {
      breadcrumb: [
        { name: 'Accueil', link: 'HomePage' },
        { name: 'Formules' }
      ]
    }
  },
  {
    path: '/explorer',
    name: 'Explorer',
    component: Explorer,
    meta: {
      breadcrumb: [
        { name: 'Accueil', link: 'HomePage' },
        { name: 'Bibliothèque' }
      ],
      isAuthenticated: true
    }
  },
  {
    path: '/onboarding',
    name: 'Onboarding',
    component: Onboarding
  },
  {
    path: '/teacher/:folderId/stats',
    name: 'TeacherStats',
    component: TeacherStats,
    meta: { isAuthenticated: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
